<template>
    <tr
        v-for="month in row.data"
        class="row border-none group relative hover:bg-gray-tier-5"
    >
        <td
            v-for="(column, key) in columns"
            class="relative group first-of-type:!pl-6 !px-2.5 py-2 at1024:py-[14px]"
            :class="[
                {
                    'whitespace-nowrap':
                        !_.has(column, 'noWrap') && !column.noWrap === true,
                },
                { 'last-of-type:!pr-8': isSubTable },
                (typeof column.cellClass === 'function'
                    ? column.cellClass(month)
                    : column.cellClass) ?? '',
            ]"
        >
            <span
                v-if="
                    !(typeof column.component === 'function'
                        ? column.component(month)
                        : column.component)
                "
                v-html="
                    typeof column.path === 'function'
                        ? column.path(month)?.length
                            ? column.path(month)
                            : '—'
                        : String(
                              _.get(
                                  month,
                                  column.path,
                                  column.placeholder ?? '—'
                              )
                          ).length
                        ? _.get(month, column.path, column.placeholder ?? '—')
                        : column.placeholder ?? '—'
                "
            />
            <component
                :is="
                    typeof column.component === 'function'
                        ? column.component(month)
                        : column.component
                "
                v-else
                :placeholder="column.placeholder"
                v-bind="
                    typeof column.props === 'function'
                        ? column.props(month)
                        : column.props ?? {}
                "
            />
        </td>
    </tr>
    <tr class="text-gray-475 bg-gray-tier-6">
        <td
            :colspan="columns.length - 1"
            class="relative group first-of-type:!pl-6 font-bold !px-2.5 py-2 type-primary at1024:py-[14px]"
        >
            <WarehouseCodeToStateFormat :code="_.toString(row.warehouse)" />
        </td>
        <td
            class="relative group first-of-type:!pl-6 !px-2.5 py-2 at1024:py-[14px]"
        >
            <MoneyFormat :amount="row.total_sales" />
        </td>
    </tr>
</template>
<script setup>
import _ from "lodash";
import { ref } from "vue";

import { WarehouseCodeToStateFormat, MoneyFormat } from "@/Components";

const emit = defineEmits(["toggle-row"]);

const props = defineProps([
    "name",
    "columns",
    "row",
    "subTable",
    "isSubTable",
    "selectable",
    "selected",
]);

const showSubTable = ref(props.subTable?.show ?? false);
</script>
